// extracted by mini-css-extract-plugin
export default {"refreshStyle":"UnitStatsTable_refreshStyle__1oqZf","spinRefresh":"UnitStatsTable_spinRefresh__WgtjA","refreshStyleLoading":"UnitStatsTable_refreshStyleLoading__LENlC"};